import React, { useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { 
    Box,
    ClickAwayListener,
    Typography,
    FormControl,
    InputLabel,
    Select,
    IconButton
} from '@material-ui/core';
import { isEmpty, get } from '../../../utils/lodash';
import LightTooltip from '../../common/LightTooltip';
import FilterIcon from '../Icons/filterIcon';
import HighlightOffRoundedIcon from '@material-ui/icons/HighlightOffRounded';

const useStyles = makeStyles(theme => ({
    filterText: {
        fontSize: 14,
        fontWeight: 'bold'
    },
    formControl: {
        width: theme.spacing(30.5),
        margin: theme.spacing(2, 1)
    },
    filterIconWrapper: {
        display: 'flex',
        position: 'relative'
    },
    filterIcon: {
        padding: theme.spacing(0),
        margin: theme.spacing(0, 1)
    },
    filterWrapper: {
        position: 'absolute',
        top: theme.spacing(-2),
        right: theme.spacing(0.25),
        background: '#FFFFFF 0% 0% no-repeat padding-box',
        boxShadow: '0px 0px 6px #00000029',
        borderRadius: theme.spacing(1.5),
        padding: theme.spacing(0, 1.5),
        fontSize: 10,
        letterSpacing: 0.1,
        display: 'flex',
        whiteSpace: 'nowrap'
    },
    closeIcon: {
        fontSize: theme.spacing(2.5),
        position: 'absolute',
        right: -8,
        top: -8,
        fill: '#AAA9A9',
        stroke: '#fff',
        background: '#fff',
        borderRadius: '50%',
        cursor: 'pointer'
    }
}));

const Filter = (props) => {
    const classes = useStyles();
    const [ showFilterTooltip, setShowFilterTooltip ] = useState(false);
    const {
        savedSearch,
        systemSearch,
        activationSavedSearch,
        handleFilterChange,
        handleFilterReset,
        field,
        selectedFilter
    } = props;

    const handleFilter = e => {
        handleFilterChange(e);
        setShowFilterTooltip(false);
    };
    
    const resetFilter = () => {
        handleFilterReset();
    };

    return (
        <LightTooltip
            title={
                <ClickAwayListener onClickAway={() => setShowFilterTooltip(false)}>
                    <Box>
                        <Typography className={classes.filterText}>Filter</Typography>
                        <FormControl className={classes.formControl}>
                            <InputLabel htmlFor="grouped-native-select">System Groups / Saved Search</InputLabel>
                            <Select
                                native
                                defaultValue={'All'}
                                id="grouped-native-select"
                                onChange={e => handleFilter(e)}
                            >
                                <option key={`filter-all`} value="All">All</option>
                                {field === 'Alerts' &&
                                !isEmpty(savedSearch) && (
                                <optgroup label="Saved Searches">
                                    {savedSearch.map((search, index) => <option key={`filter-alerts-${index}`} value={index}>{search.name}</option>)}
                                </optgroup>
                                )}
                                {field === 'Alerts' &&
                                !isEmpty(systemSearch) && (
                                <optgroup label="System Groups">
                                    {systemSearch.map((search, index) => (
                                    <option key={`filter-systemg-${index}`}  value={savedSearch.length + index}>{search.name}</option>
                                    ))}
                                </optgroup>
                                )}
                                {field === 'Activations' &&
                                !isEmpty(activationSavedSearch) && (
                                <optgroup label="Saved Searches">
                                    {activationSavedSearch.map((search, index) => (
                                    <option key={`filter-activations-${index}`} value={index}>{search.name}</option>
                                    ))}
                                </optgroup>
                                )}
                            </Select>
                        </FormControl>
                    </Box>
                </ClickAwayListener>
            }
            open={showFilterTooltip}
            placement="bottom-end"
            arrow
        >
            <div className={classes.filterIconWrapper}>
                <IconButton className={classes.filterIcon} onClick={() => setShowFilterTooltip(true)}>
                    <FilterIcon />
                </IconButton>
                {selectedFilter[field].name !== 'All' && (
                <div className={classes.filterWrapper}>
                    <Typography>{selectedFilter[field].name}</Typography>
                    <HighlightOffRoundedIcon className={classes.closeIcon} onClick={resetFilter} />
                </div>
                )}
            </div>
        </LightTooltip>
    )
}

export default Filter;
